import { render, staticRenderFns } from "./SequencingParent.vue?vue&type=template&id=45f81e14&"
import script from "./SequencingParent.vue?vue&type=script&lang=js&"
export * from "./SequencingParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports